<template>
  <v-footer padless class="d-block">
    <div class="text-center mt-2">
      <v-btn
        v-for="(icon, i) in icons"
        :key="i"
        :href="icon.href"
        :color="icon.color"
        target="_blank"
        icon
      >
        <v-icon>{{ icon.icon }}</v-icon>
      </v-btn>
    </div>
    <v-col class="align-center justify-center text-center" padless>
      <div class="text-caption text-sm-body-2">
        Copyright &copy; {{ new Date().getFullYear() }}
        <strong>CCB•OBS</strong>. Tous droits réservés
      </div>
    </v-col>
  </v-footer>
</template>

<script>
export default {
  name: "FooterComponent",
  created() {},
  data() {
    return {
      icons: [
        {
          icon: "mdi-github",
          href: "https://github.com/ccbobs13",
          color: "black",
        },
        {
          icon: "mdi-instagram",
          href: "https://www.instagram.com/ccb_obs",
          color: "red",
        },
        {
          icon: "mdi-linkedin",
          href: "http://linkedin.com/in/samyr-christian-yentéma-thiombiano-326627231",
          color: "primary",
        },
        {
          icon: "mdi-twitter",
          href: "https://twitter.com/ccb_obs",
          color: "light-blue",
        },
      ],
    };
  },
  props: {},
  methods: {},
};
</script>

<style lang="css" scoped></style>
